var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app-loading-spinner"}},[_c('img',{attrs:{"alt":"Loading","src":require("../assets/media/loading.gif")}})])
}]

export { render, staticRenderFns }